import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";
import {CamJobModel} from "../../../api/entity/camJob.model";

@Injectable({
    providedIn: 'root'
})
export class CamJobRepository extends AbstractRepositoryV2<CamJobModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('CamJob', serviceElementsFactory, injector);
    }
}
